var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batch-opt-main" },
    [
      _c("el-row", { staticStyle: { height: "40px" } }, [
        _c(
          "span",
          {
            staticClass: "title-text view-title-name",
            staticStyle: { "line-height": "40px" },
          },
          [_vm._v(_vm._s(_vm.$t("panel.batch_opt")))]
        ),
      ]),
      _vm.mixProperties && _vm.batchOptChartInfo
        ? _c("chart-style", {
            staticClass: "chart-style-main",
            attrs: {
              param: _vm.param,
              view: _vm.batchOptChartInfo,
              chart: _vm.batchOptChartInfo,
              properties: _vm.mixProperties,
              "property-inner-all": _vm.mixPropertiesInner,
            },
            on: {
              calcStyle: _vm.calcStyle,
              onColorChange: _vm.onColorChange,
              onSizeChange: _vm.onSizeChange,
              onLabelChange: _vm.onLabelChange,
              onTooltipChange: _vm.onTooltipChange,
              onTotalCfgChange: _vm.onTotalCfgChange,
              onChangeXAxisForm: _vm.onChangeXAxisForm,
              onChangeYAxisForm: _vm.onChangeYAxisForm,
              onChangeYAxisExtForm: _vm.onChangeYAxisExtForm,
              onChangeSplitForm: _vm.onChangeSplitForm,
              onTextChange: _vm.onTextChange,
              onLegendChange: _vm.onLegendChange,
              onMarginChange: _vm.onMarginChange,
              onSuspensionChange: _vm.onSuspensionChange,
            },
          })
        : _c("el-row", [
            _c("div", { staticClass: "view-selected-message-class" }, [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "margin-left": "10px",
                    "font-weight": "bold",
                    "line-height": "20px",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.select_view")))]
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }